export default __webpack_public_path__ + "static/media/feedback.2f5ce35c.svg";